import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20artistic%20illustration%20background%20with%20vibrant%20dynamic%20comic%20panel%20elements%20speed%20lines%20and%20action%20effects%20in%20warm%20orange%20and%20coral%20tones%20against%20dark%20background%20cinematic%20composition%20dramatic%20lighting&width=1920&height=800&seq=hero-bg-kr-comics&orientation=landscape"
          alt="韩国漫画背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
          韩国漫画 · 免费韩漫大全
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          最新最全的正版韩国漫画在线阅读平台，涵盖热血动作、奇幻冒险、浪漫恋爱、悬疑惊悚等各类题材，高清画质，流畅阅读，每日更新
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/action"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            立即阅读
          </Link>
          <Link
            to="/category/fantasy"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm border border-white/20"
          >
            探索分类
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          {[
            { value: '12+', label: '漫画作品' },
            { value: '48+', label: '更新章节' },
            { value: '1M+', label: '忠实读者' },
          ].map(stat => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}